import React from "react";

/**
 * DashboardGreeting — structural component used by Phase C role dashboards.
 *
 * Props:
 *   user            — the current user object (needs `first_name` or `name`)
 *   perspectiveLabel — e.g. "Executive Operations", "Leasing & Driver Operations"
 *   now              — optional Date for testability (defaults to Date.now)
 *
 * Renders:
 *   H1: "Good morning|afternoon|evening, {first_name}"
 *   Subtext: perspectiveLabel in the standard eyebrow style.
 *
 * Does NOT fetch data. Does NOT render widgets. Pure structural piece.
 */
export default function DashboardGreeting({ user, perspectiveLabel, now }) {
  const first = (user?.first_name || (user?.name || "").split(" ")[0] || "").trim() || "there";
  const hour = (now || new Date()).getHours();
  const salutation =
    hour < 12 ? "Good morning" :
    hour < 18 ? "Good afternoon" :
                "Good evening";
  return (
    <div className="mb-6" data-testid="dashboard-greeting">
      <div className="text-[10.5px] uppercase tracking-widest text-steel font-medium mb-1"
           data-testid="dashboard-greeting-perspective">
        {perspectiveLabel || "\u00A0"}
      </div>
      <h1
        className="font-display text-carbon dark:text-road-white text-[28px] sm:text-[32px] leading-tight"
        data-testid="dashboard-greeting-heading"
      >
        {salutation}, <span className="text-coach-blue">{first}</span>.
      </h1>
    </div>
  );
}
